import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Login from 'components/LandingPage/Login';

import { getToken } from 'constants/localStorageManager.js';

import logo from 'assets/img/logo.png';
import 'assets/scss/landingPage.css';

class PrivacyPolicy extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <header className="header inner-header">
          <div className="navbar navbar-dark">
            <div className="container d-flex justify-content-between">
              <a
                href="/home"
                className="navbar-brand d-flex align-items-center"
              >
                <img src={logo} title="Soono Logo" alt="Soono Logo" />
              </a>
              {!getToken() ? <Login /> : null}
            </div>
          </div>
        </header>

        <main role="main">
          <section className="inner-content">
            <div className="container">
              <h1>Privacy Policy</h1>
              <p className="lead">
                Protecting your private information is our priority. This
                Statement of Privacy applies to{' '}
                <a href="https://mysoono.com">https://mysoono.com</a> and Soono
                and governs data collection and usage. For the purposes of this
                Privacy Policy, unless otherwise noted, all references to Soono
                include <a href="https://mysoono.com">https://mysoono.com</a>{' '}
                and Soono. The Soono website is a Online survey development
                cloud-based software as a service company. site. By using the
                Soono website, you consent to the data practices described in
                this statement.
              </p>
              <h3>Collection of your Personal Information</h3>
              <p>
                In order to better provide you with products and services
                offered on our Site, Soono may collect personally identifiable
                information, such as your:
              </p>
              <ul>
                <li>First and Last Name</li>
                <li>E-mail Address</li>
                <li>Location</li>
              </ul>
              <p>
                Soono may also collect anonymous demographic information, which
                is not unique to you, such as your:
              </p>
              <ul>
                <li>Age</li>
                <li>Gender</li>
              </ul>
              <p>
                We do not collect any personal information about you unless you
                voluntarily provide it to us. However, you may be required to
                provide certain personal information to us when you elect to use
                certain products or services available on the Site. These may
                include: (a) registering for an account on our Site; (b)
                entering a sweepstakes or contest sponsored by us or one of our
                partners; (c) signing up for special offers from selected third
                parties; (d) sending us an email message; (e) submitting your
                credit card or other payment information when ordering and
                purchasing products and services on our Site. To wit, we will
                use your information for, but not limited to, communicating with
                you in relation to services and/or products you have requested
                from us. We also may gather additional personal or non-personal
                information in the future.
              </p>
              <h3>Use of your Personal Information</h3>
              <p>
                Soono collects and uses your personal information to operate its
                website(s) and deliver the services you have requested. <br />
                Soono may also use your personally identifiable information to
                inform you of other products or services available from Soono
                and its affiliates.
              </p>
              <h3>Sharing Information with Third Parties</h3>
              <p>
                Soono does not sell, rent or lease its customer lists to third
                parties.
              </p>
              <p>
                Soono may share data with trusted partners to help perform
                statistical analysis, send you email or postal mail, provide
                customer support, or arrange for deliveries. All such third
                parties are prohibited from using your personal information
                except to provide these services to Soono, and they are required
                to maintain the confidentiality of your information.
              </p>
              <p>
                Soono may disclose your personal information, without notice, if
                required to do so by law or in the good faith belief that such
                action is necessary to: (a) conform to the edicts of the law or
                comply with legal process served on Soono or the site; (b)
                protect and defend the rights or property of Soono; and/or (c)
                act under exigent circumstances to protect the personal safety
                of users of Soono, or the public.
              </p>
              <h3>Tracking User Behavior</h3>
              <p>
                Soono may keep track of the websites and pages our users visit
                within Soono, in order to determine what Soono services are the
                most popular. This data is used to deliver customized content
                and advertising within Soono to customers whose behavior
                indicates that they are interested in a particular subject area.
              </p>
              <h3>Automatically Collected Information</h3>
              <p>
                Information about your computer hardware and software may be
                automatically collected by Soono. This information can include:
                your IP address, browser type, domain names, access times and
                referring website addresses. This information is used for the
                operation of the service, to maintain quality of the service,
                and to provide general statistics regarding use of the Soono
                website.
              </p>
              <h3>Use of Cookies</h3>
              <p>
                The Soono website may use "cookies" to help you personalize your
                online experience. A cookie is a text file that is placed on
                your hard disk by a web page server. Cookies cannot be used to
                run programs or deliver viruses to your computer. Cookies are
                uniquely assigned to you, and can only be read by a web server
                in the domain that issued the cookie to you.
              </p>
              <p>
                One of the primary purposes of cookies is to provide a
                convenience feature to save you time. The purpose of a cookie is
                to tell the Web server that you have returned to a specific
                page. For example, if you personalize Soono pages, or register
                with Soono site or services, a cookie helps Soono to recall your
                specific information on subsequent visits. This simplifies the
                process of recording your personal information, such as billing
                addresses, shipping addresses, and so on. When you return to the
                same Soono website, the information you previously provided can
                be retrieved, so you can easily use the Soono features that you
                customized.
              </p>
              <p>
                You have the ability to accept or decline cookies. Most Web
                browsers automatically accept cookies, but you can usually
                modify your browser setting to decline cookies if you prefer. If
                you choose to decline cookies, you may not be able to fully
                experience the interactive features of the Soono services or
                websites you visit.
              </p>
              <h3>Links</h3>
              <p>
                This website contains links to other sites. Please be aware that
                we are not responsible for the content or privacy practices of
                such other sites. We encourage our users to be aware when they
                leave our site and to read the privacy statements of any other
                site that collects personally identifiable information.
              </p>
              <h3>Security of your Personal Information</h3>
              <p>
                Soono secures your personal information from unauthorized
                access, use, or disclosure. Soono uses the following methods for
                this purpose:
              </p>
              <ul>
                <li>SSL Protocol</li>
              </ul>
              <p>
                When personal information (such as a credit card number) is
                transmitted to other websites, it is protected through the use
                of encryption, such as the Secure Sockets Layer (SSL) protocol.
              </p>
              <p>
                We strive to take appropriate security measures to protect
                against unauthorized access to or alteration of your personal
                information. Unfortunately, no data transmission over the
                Internet or any wireless network can be guaranteed to be 100%
                secure. As a result, while we strive to protect your personal
                information, you acknowledge that: (a) there are security and
                privacy limitations inherent to the Internet which are beyond
                our control; and (b) security, integrity, and privacy of any and
                all information and data exchanged between you and us through
                this Site cannot be guaranteed.
              </p>
              <h3>Children Under Thirteen</h3>
              <p>
                Soono does not knowingly collect personally identifiable
                information from children under the age of thirteen. If you are
                under the age of thirteen, you must ask your parent or guardian
                for permission to use this website.
              </p>
              <h3>E-mail Communications</h3>
              <p>
                From time to time, Soono may contact you via email for the
                purpose of providing announcements, promotional offers, alerts,
                confirmations, surveys, and/or other general communication.
              </p>
              <p>
                If you would like to stop receiving marketing or promotional
                communications via email from Soono, you may opt out of such
                communications by clicking on the UNSUBSCRIBE button.
              </p>
              <h3>External Data Storage Sites</h3>
              <p>
                We may store your data on servers provided by third party
                hosting vendors with whom we have contracted.
              </p>
              <h3>Refund Policy; Chargeback.</h3>
              <p>
                <b>Refund Policy.</b> If Customer is not satisfied with its
                initial purchase of a Service, Customer may terminate such
                Service by providing us a written notice, within 30 days of
                having first ordered such Services (the “Refund Period”). In the
                event that Customer terminates such initial purchase of a
                Service, within the Refund Period, we will refund Customer the
                Subscription Fees paid in respect of such terminated
                Subscription, in the same currency we were originally paid (the
                “Refund”). The Refund is applicable only to the initial purchase
                of the Service by Customer and does not apply to any additional
                purchases, upgrades, modification or renewals of such Service.
                Please note that the Refund amount may be different than the
                amount Customer was charged due to currency changes and third
                party fees, such as wire transfer fees, and we shall not be
                responsible for any differences caused by change of currency
                exchange rates or fees that Customer was charged by third
                parties. After the Refund Period, the Subscription Fees are
                non-refundable and non-cancellable. To the extent permitted by
                law, if we find that a notice of cancellation has been given in
                bad faith or in an illegitimate attempt to avoid payment for
                Services actually received and enjoyed, we reserve our right to
                reject Customer’s Refund request
              </p>
              <h3>Changes to this Statement</h3>
              <p>
                Soono reserves the right to change this Privacy Policy from time
                to time. We will notify you about significant changes in the way
                we treat personal information by sending a notice to the primary
                email address specified in your account, by placing a prominent
                notice on our site, and/or by updating any privacy information
                on this page. Your continued use of the Site and/or Services
                available through this Site after such modifications will
                constitute your: (a) acknowledgment of the modified Privacy
                Policy; and (b) agreement to abide and be bound by that Policy.
              </p>
              <h3>Contact Information</h3>
              <p>
                Soono welcomes your questions or comments regarding this
                Statement of Privacy. If you believe that Soono has not adhered
                to this Statement, please contact Soono at:
              </p>
              <p>
                Soono
                <br />
                PO Box: 490573
                <br />
                Everett, MA 02149
                <br />
                Email Address:
                <br />
                <a href="mailto: info@mysoono.com">info@mysoono.com</a>
                <br />
                Telephone number: <br />
                <a href="tel: 781-727-4545">(781)727-4545</a>
                <br />
                <br />
                Effective as of May 06, 2019
              </p>
            </div>
          </section>
        </main>

        <footer className="text-muted pt-4 pb-4">
          <div className="container">
            <p className="float-right">
              {!getToken() ? <a href="/#growBusiness">About Us</a> : null}
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-use">Terms and Conditions</Link>
            </p>
            <p>
              © {new Date().getFullYear()} All rights reserved by{' '}
              <Link to="/home">Soono</Link>.
            </p>
          </div>
        </footer>
      </div>
    );
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/containers/PrivacyPolicy.js